import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as OilCan } from "assets/svg/oilCan.svg";
import T from "i18n";
import Base from "./Base";

const MSLA = ({ className }) => {
  const classes = ["MSLA"];
  if (className) classes.push(className);

  return (
    <Base
      className={className}
      Svg={OilCan}
      label={T({ path: "button.MSLA" })}
    />
  );
};

MSLA.displayName = "MSLA";

MSLA.propTypes = {
  className: PropTypes.string,
};

MSLA.defaultProps = {
  className: null,
};

export default MSLA;
